module.exports = __webpack_public_path__ + "static/media/36-4.974d9b77.mp3";